import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToasterState, ToasterSeverity } from '../types';

interface CommonState {
  toaster: ToasterState;
}

const initialState: CommonState = {
  toaster: {
    open: false,
    message: '',
    severity: 'success'
  }
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setToaster: (state, action: PayloadAction<Partial<ToasterState> & { open: boolean }>) => {
      state.toaster = { ...state.toaster, ...action.payload };
    },
    showToast: (state, action: PayloadAction<{ message: string; severity?: ToasterSeverity }>) => {
      state.toaster = {
        open: true,
        message: action.payload.message,
        severity: action.payload.severity || 'success'
      };
    },
    hideToast: (state) => {
      state.toaster.open = false;
    }
  }
});

export const { setToaster, showToast, hideToast } = commonSlice.actions;
export default commonSlice.reducer;
